import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";
import Navbar from "@/components/skinfill/Navbar";
import HeroVideo from "@/components/skinfill/HeroVideo";
import ProductHero from "@/components/skinfill/ProductHero";
import Manifesto from "@/components/skinfill/Manifesto";
import SignatureMoment from "@/components/skinfill/SignatureMoment";
import Pillars from "@/components/skinfill/Pillars";
import Formula from "@/components/skinfill/Formula";
import Editorial from "@/components/skinfill/Editorial";
import BeforeAfter from "@/components/skinfill/BeforeAfter";
import Journey from "@/components/skinfill/Journey";
import Professionals from "@/components/skinfill/Professionals";
import Distributor from "@/components/skinfill/Distributor";
import EnquiryForm from "@/components/skinfill/EnquiryForm";
import Footer from "@/components/skinfill/Footer";
import MobileStickyCTA from "@/components/skinfill/MobileStickyCTA";
import StickyEnquire from "@/components/skinfill/StickyEnquire";
import CursorGlow from "@/components/skinfill/CursorGlow";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Disclaimer from "@/pages/Disclaimer";

const Home = () => {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="bg-[#FAF7F5]">
      <Navbar />
      <main>
        <HeroVideo />
        <ProductHero />
        <Manifesto />
        <SignatureMoment />
        <Pillars />
        <Formula />
        <Editorial />
        <BeforeAfter />
        <Journey />
        <Professionals />
        <Distributor />
        <EnquiryForm />
      </main>
      <Footer />
      <MobileStickyCTA />
      <StickyEnquire />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <CursorGlow />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/disclaimer" element={<Disclaimer />} />
      </Routes>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;
